<template>
  <div>
    <div class="product-coupon" v-if="coupon_list && coupon_list.length">
      <div class="product-coupon-item" v-for="(coupon, index) in coupon_list" :key="coupon.coupon_code">
        <span class="product-coupon-item-label">可用券</span>
        <span class="product-coupon-item-value">满{{coupon.satisfy_amount}}减{{coupon.amount}}</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["coupon_list"],
};
</script>
<style lang="scss" scoped>

.product {
  &-coupon {
    margin-bottom: 10px;
    &-item {
      display: inline-flex;
      margin-right: 10px;
      height: 24px;
      background: url(~@/assets/img/coupon/tag_coupon_bg.png) no-repeat;
      background-size: cover;
      font-size: 13px;
      border-radius: 4px;
      align-items: center;
      padding-right: 2px;
      font-weight: 600;
      margin-bottom: 5px;
      &-label {
        padding: 0 10px;
        text-align: center;
        color: white;
        line-height: 24px;
      }
      &-value {
        padding: 0 15px;
        height: 20px;
        border-radius: 4px;
        color: #f84c0f;
        line-height: 20px;
        background-color: #fff;
      }
    }
  }
}

</style>